<template>
  <Publication :publication="last_publication.data" />
</template>
<script>
import { reactive } from "vue";
import Publication from "../common/Publication/Publication.vue";

export default {
  components: {
    Publication
  },
  props: {
    url: {
      type: String,
      default: ""
    }
  },
  async setup(props) {
    let parser = new DOMParser();
    let handle = "";
    let doc;
    let last_publication = reactive({ data: {} });
    //GET DOM COMMUNITY BECAUSE DE F.. S.. "REST" API DOES NOT PROVIDE "LAST SUBMISSION" ENDPOINT
    await fetch(props.url)
      .then(response => response.text())
      .then(async response => {
        doc = parser.parseFromString(response, "text/html");
        handle = doc
          .querySelector(
            "#aspect_discovery_CommunityRecentSubmissions_div_community-recent-submission .artifact-title a"
          )
          .getAttribute("href");
        await fetch(
          `https://repositorio.igp.gob.pe/rest${handle}?expand=metadata,bitstreams`
        )
          .then(response => response.json())
          .then(data => {
            last_publication.data = data;
          });
      });
    return {
      last_publication
    };
  }
};
</script>
<style lang="scss"></style>
